<template>
  <div class="reportindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>模板列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/checkreport/create')"
          >创建模板</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入模板名称"
            v-model="templateName"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="reportList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <ItemInfo
      :state="editState"
      @close="editState = false"
      :pageList="editUnit"
      :columnsEdit="editColumns"
    />
    <!-- <ToolsInfo :state="toolState" @close="toolState = false" :user="toolData" /> -->
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import {
  reportList,
  deleteReport,
  updateReport,
  getList
} from '@/api/checkreport'
import { queryEquipment } from '@/api/dictionary'

import TzTable from '@/components/tz-table/Index.vue'
import ItemInfo from './components/ItemInfo'
// import ToolsInfo from './components/ToolsInfo'
export default {
  components: {
    TzTable,
    ItemInfo
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      templateName: '',
      editState: false,
      toolState: false,
      toolData: {},
      editUnit: [],
      editColumns: [],
      reportList: [],
      deviceTypeList: [],
      templateList: [],
      itempageList: [],
      toolspageList: [],
      toolsColumns: [
        {
          field: 'toolname',
          title: '仪器名称'
        },
        {
          field: 'px',
          title: '排序'
        }
      ],
      itemColumns: [
        {
          field: 'sort',
          title: '序号'
        },
        {
          field: 'itemType',
          title: '事项类型'
        },
        {
          field: 'itemName',
          title: '事项名称'
        },
        {
          field: 'resultValue',
          title: '检测结果默认值'
        },
        {
          field: 'qualifiedType',
          title: '检测合格类型'
        }
      ],
      columns: [
        {
          field: 'templateName',
          title: '模板名称'
        },
        {
          field: 'templateReport',
          title: '模板对应报告文件名称'
        },
        {
          field: 'deviceType',
          title: '设备类型'
        },
        {
          field: 'testbasis',
          title: '检测依据'
        },
        {
          field: 'templateType',
          title: '模板类型'
        },
        {
          field: 'maxNotpass',
          title: '最大不符合项数'
          // rules: [{ required: true, message: '描述必填', trigger: 'blur' }]
        },
        {
          field: 'status',
          title: '状态'
        },
        // {
        //   field: 'value',
        //   title: '内容'
        // },
        // {
        //   title: '状态',
        //   type: 'switch',
        //   payload: {
        //     field: 'deactive',
        //     change: (row) => this.changeUnitState(row)
        //   }
        // },
        {
          title: '事项信息',
          width: '100',
          type: 'btn',
          payload: [
            {
              name: '详情',
              type: 'info',
              click: (row) => {
                console.log('详情', row)
                let edirArr = JSON.parse(JSON.stringify(row))
                this.getInfos(edirArr.id, '事项')
              }
            }
          ]
        },
        {
          title: '仪器信息',
          width: '100',
          type: 'btn',
          payload: [
            {
              name: '详情',
              type: 'info',
              click: (el) => {
                console.log('详情', el)
                let edirArr = JSON.parse(JSON.stringify(el))
                this.getInfos(edirArr.id, '仪器')
              }
            }
          ]
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                let edirArr = JSON.parse(JSON.stringify(row))
                this.$router.push({
                  path: '/checkreport/detail',
                  query: edirArr
                })
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  created() {
    this.queryEquipmentFn()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getReportList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getReportList()
    },

    //获取设备类型
    queryEquipmentFn() {
      let types = ['equipment_type', 'template_type']
      queryEquipment(types).then((res) => {
        console.log(res.data, '设备类型')
        this.deviceTypeList = res.data.equipment_type
        this.templateList = res.data.template_type
      })
    },
    // 列表
    getReportList() {
      let params = {
        templateName: this.templateName,
        pageSize: this.size,
        pageNum: this.page
      }
      reportList(params).then((res) => {
        if (res.code == 200) {
          let reportArr = res.data.records
          this.total = res.data.total
          this.reportList = reportArr.map((item) => {
            return {
              id: item.id,
              status: Number(item.status) === 1 ? '启用' : '禁用',
              templateName: item.templateName,
              templateReport: item.templateReport,
              templateType: item.dictName_templateType,
              testbasis: item.testbasis,
              maxNotpass: item.maxNotpass,
              deviceType: item.dictName_deviceType,
              tools: item.tools,
              items: item.items
            }
          })
          console.log(this.reportList)
        }
      })
    },
    //获取事项及仪器信息
    getInfos(el, name) {
      this.$loading({
        text: '信息加载中'
      })
      let params = {
        id: el
      }
      getList(params).then((res) => {
        if (res.code == 200) {
          this.$loading().close()
          this.itempageList = res.data.items ? res.data.items : []
          this.toolspageList = res.data.tools ? res.data.tools : []
          // 显示弹框
          this.editState = true
          if (name === '事项') {
            this.editUnit = this.itempageList
            this.editColumns = this.itemColumns
          } else if (name === '仪器') {
            this.editUnit = this.toolspageList
            this.editColumns = this.toolsColumns
          }
        }
        this.$loading().close()
      })
    },
    // 编辑
    changeDict(infos) {
      console.log(infos)
      this.$loading({
        text: '模板更新中'
      })
      let devices = this.deviceTypeList.find(
        (el) => el.label === infos.deviceType
      )
      if (devices) infos.deviceType = devices.value
      let templates = this.templateList.find(
        (el) => el.label === infos.templateType
      )
      if (templates) infos.templateType = templates.value
      console.log(infos)
      let updateparams = {
        ...infos
      }
      updateReport(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getReportList()
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteReport(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getReportList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.getReportList()
    }
  },
  mounted() {
    this.getReportList()
  }
}
</script>

<style></style>
